import { render, staticRenderFns } from "./KategoriTable.vue?vue&type=template&id=24a65007&scoped=true&"
import script from "./KategoriTable.vue?vue&type=script&lang=js&"
export * from "./KategoriTable.vue?vue&type=script&lang=js&"
import style0 from "./KategoriTable.vue?vue&type=style&index=0&id=24a65007&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a65007",
  null
  
)

export default component.exports